import { useState } from 'react';
import { regions, years, sortOptions } from '@/mocks/categories';
import type { SortValue } from '@/utils/video';

interface FilterBarProps {
  region: string;
  year: string;
  sort: SortValue;
  onRegionChange: (v: string) => void;
  onYearChange: (v: string) => void;
  onSortChange: (v: SortValue) => void;
}

interface PillGroupProps {
  label: string;
  options: { value: string; label: string }[];
  active: string;
  onChange: (v: string) => void;
}

function PillGroup({ label, options, active, onChange }: PillGroupProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4 py-3 border-b border-background-200 last:border-b-0">
      <span className="text-sm font-medium text-foreground-500 sm:w-16 shrink-0 sm:pt-1.5">{label}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            className={`px-3 py-1.5 rounded-md text-sm transition-colors whitespace-nowrap cursor-pointer ${
              active === opt.value
                ? 'bg-primary-500 text-background-50 font-medium'
                : 'bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-600'
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterBar({
  region,
  year,
  sort,
  onRegionChange,
  onYearChange,
  onSortChange,
}: FilterBarProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const content = (
    <>
      <PillGroup
        label="地区"
        active={region}
        onChange={onRegionChange}
        options={regions.map((r) => ({ value: r, label: r }))}
      />
      <PillGroup
        label="年份"
        active={year}
        onChange={onYearChange}
        options={years.map((y) => ({ value: y, label: y }))}
      />
      <PillGroup
        label="排序"
        active={sort}
        onChange={(v) => onSortChange(v as SortValue)}
        options={sortOptions}
      />
    </>
  );

  return (
    <div className="rounded-lg bg-background-50 border border-background-200">
      <button
        type="button"
        onClick={() => setMobileOpen((v) => !v)}
        className="sm:hidden w-full flex items-center justify-between px-4 py-3 cursor-pointer"
      >
        <span className="flex items-center gap-2 text-sm font-medium text-foreground-800">
          <i className="ri-filter-3-line text-primary-500"></i>
          筛选与排序
        </span>
        <i className={`${mobileOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-foreground-500`}></i>
      </button>

      <div className={`${mobileOpen ? 'block' : 'hidden'} sm:block px-4 pb-2 sm:py-2`}>{content}</div>
    </div>
  );
}